import { useAiContext } from "@/hooks/use-ai-context"
import { useAiChat } from "@/hooks/use-ai-chat"
import { Sparkles } from "lucide-react"

const PROMPTS_BY_PAGE: Record<string, string[]> = {
  "/dashboard": [
    "Podsumuj dzisiejszy pipeline",
    "Jaki mam przychód w tym miesiącu?",
    "Jakie mam zaległe zadania?",
    "Porównaj sprzedaż tego i zeszłego miesiąca",
  ],
  "/deals": [
    "Pokaż podsumowanie pipeline",
    "Jakie transakcje są najdłużej w jednej fazie?",
    "Jaka jest prognoza sprzedaży?",
  ],
  "/companies": [
    "Szukaj firmy...",
    "Ile mam firm w systemie?",
    "Pokaż ostatnio dodane firmy",
  ],
  "/contacts": [
    "Szukaj kontaktu...",
    "Ile mam kontaktów?",
  ],
  "/tasks": [
    "Co mam do zrobienia dziś?",
    "Jakie zadania są zaległe?",
    "Pokaż nadchodzące zadania",
  ],
  "/invoices": [
    "Jakie faktury są przeterminowane?",
    "Pokaż nieopłacone faktury",
  ],
}

const CONTEXT_PROMPTS: Record<string, string[]> = {
  Deal: [
    "Podsumuj tę transakcję",
    "Jakie zadania są powiązane?",
    "Pokaż historię tej transakcji",
  ],
  Company: [
    "Pokaż wszystkie transakcje z tą firmą",
    "Kim są kontakty w tej firmie?",
    "Pokaż historię tej firmy",
  ],
  Contact: [
    "Z jakimi firmami jest powiązany ten kontakt?",
    "Pokaż transakcje z tym kontaktem",
  ],
  Task: [
    "Pokaż szczegóły tego zadania",
  ],
  ServiceTicket: [
    "Podsumuj to zgłoszenie",
    "Ile czasu poświęcono na to zgłoszenie?",
  ],
}

const DEFAULT_PROMPTS = [
  "Pokaż statystyki dashboardu",
  "Jakie mam dziś zadania?",
  "Pokaż podsumowanie pipeline",
  "Jaki mam przychód w tym miesiącu?",
]

export function AiSuggestedPrompts() {
  const context = useAiContext()
  const { send } = useAiChat()

  // Pick prompts based on context
  let prompts: string[]
  if (context.context_type && CONTEXT_PROMPTS[context.context_type]) {
    prompts = CONTEXT_PROMPTS[context.context_type]
  } else {
    const basePath = "/" + (context.current_page.split("/")[1] || "dashboard")
    prompts = PROMPTS_BY_PAGE[basePath] || DEFAULT_PROMPTS
  }

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-6 px-6">
      <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[var(--bg-surface-raised)]">
        <Sparkles size={20} className="text-[var(--text-muted)]" />
      </div>
      <div className="text-center">
        <h3 className="text-sm font-semibold text-foreground">OkeyAI</h3>
        <p className="mt-1 text-xs text-muted-foreground">
          Zapytaj o dane CRM, twórz rekordy, analizuj sprzedaż
        </p>
      </div>
      <div className="flex w-full flex-col gap-2">
        {prompts.map((prompt) => (
          <button
            key={prompt}
            onClick={() => send(prompt)}
            className="rounded-lg border-0 bg-[var(--bg-surface)] px-3 py-2.5 text-left text-xs text-muted-foreground shadow-[0_0_2px_rgba(28,40,64,0.18),0_1px_3px_rgba(24,41,75,0.04)] transition-all hover:text-foreground hover:shadow-[0_0_2px_rgba(28,40,64,0.24),0_2px_6px_rgba(24,41,75,0.06)]"
          >
            {prompt}
          </button>
        ))}
      </div>
    </div>
  )
}
